import { render } from "./device-small.vue?vue&type=template&id=4b14ba46"
import script from "./device-small.vue?vue&type=script&lang=js"
export * from "./device-small.vue?vue&type=script&lang=js"

import "./device-small.vue?vue&type=style&index=0&id=4b14ba46&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__